import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/consent";

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => !getConsent());
  if (!open) return null;
  const choose = c => { setConsent(c); setOpen(false); };
  return <div className="mk-cookie" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
    <Cookie size={22} className="mk-cookie-ic" />
    <p>We'd like to use analytics cookies to understand how visitors use our site and improve it. They stay off unless you accept. <Link to="/cookies" data-testid="cookie-banner-policy-link">Cookie Policy</Link></p>
    <div className="mk-cookie-actions">
      <button className="mk-btn ghost sm" onClick={() => choose("rejected")} data-testid="cookie-reject-button">Reject</button>
      <button className="mk-btn ghost sm" onClick={() => choose("accepted")} data-testid="cookie-accept-button">Accept</button>
    </div>
  </div>;
};
